import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { deleteFMPTracker, post, } from '../../api';

import IpsFMPProjectGrid from '../../components/ProjectsGrid/IpsFMPProjectGrid';

import IpsFMPProjectList from 'components/ProjectsList/IpsFMPProjectList';
import IPSFMPViewType from 'components/ViewType/IPSFMPViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import Button from 'components/Button';
import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import { directToProject } from '../../utils/Dashboard';
import SpinnerNew from "../../components/Spinner/SpinnerNew";
import asbuiltsData from './builts.json'

export default withRouter(function FMPTrackerASBuilts(props) {
  const { context, history, cardview, onViewTypeChange, projectList } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});
  let tab = history.location.pathname.split('/')[2]

  useEffect(() => {
    getProjects();
  }, []);

  async function getProjects() {
    
      //spinnerOn();
      setIsLoading(true);

      const result = await post(`fmpprojects`, '', {});

      setProjects(result?.data?.filter(everyProject => everyProject.fmpTrackerStatusList.includes('FMP_B')));
      // setProjects(result.data);
      //spinnerOff();
      setIsLoading(false);
    
  }
  function goToProject(project) {
    


    directToProject(project,history,'fmptracker_asbuilts',context)
  }
  function handleButtonClick(project) {
    history.push(`/ipsdatatracker/newproject`);
    context.setProjectTab('fmptracker_asbuilts');

  }

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function handleDeleteBtnClick(project) {
    setConfirmDialogDetails({
      title: `Do you want to Delete ${project.stationName}?`,
      handleCancel: handleCancel,
      submitFunctionArgs: project,
      handleSubmit: deleteFmpTracker,
      confirmButtonName: 'Yes,Delete'
    })
    setIsModalOpen(true)
  }
  async function deleteFmpTracker(project) {
    await deleteFMPTracker(project)
    getProjects()
    setIsModalOpen(false)
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <SpinnerNew display={isLoading}/>
        <div style={{ flexGrow: 1 }} />
        <IPSFMPViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'FMP_B'}
          tstatus={'FMP_B'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsFMPProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          handleDeleteBtnClick={handleDeleteBtnClick}
          {...props}
        />
      ) : (
        <IpsFMPProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
          tabView={tab}
        />
      )}
      <ConfirmDialog
        show={isModalOpen}
        title={confirmDialogDetails.title}
        handleCancel={confirmDialogDetails.handleCancel}
        submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
        handleSubmit={confirmDialogDetails.handleSubmit}
        confirmButtonName={confirmDialogDetails.confirmButtonName}
        cancelButtonName={'No,Cancel'}
      />

    </Fragment>
  );
});